import { core } from "react-page-maker";

class GKEvent {
  constructor() {
    // supported events
    this.event = {
      notification: [],
      updateState: [],
      updateActiveHeader: [],
      updatePageSetting: [],
      importLayout: [],
      updateHeaderFooter: [],
    };
  }

  notification = (variant, message) => {
    // trigger all events
    this.event.notification.forEach((e) => e(variant, message));
  };

  updateState = (key, value) => {
    // trigger all events
    this.event.updateState.forEach((e) => e(key, value));
  };

  updateActiveHeader = (element, active) => {
    // trigger all events
    this.event.updateActiveHeader.forEach((e) => e(element, active));
  };

  updateHeaderFooter = (type, html) => {
    this.event.updateHeaderFooter.forEach((e) => e(type, html));
  };

  updatePageSetting = (block) => {
    // trigger all events
    this.event.updatePageSetting.forEach((e) => e(block));
  };

  importLayout = () => {
    // trigger all events
    this.event.importLayout.forEach((e) => e());
  };

  /**
   * function to add event
   * @param {String} eventName
   * @param {function} cb - callback
   */
  addEventListener = (eventName, cb = () => {}) => {
    let returnCB = null;

    if (typeof cb !== "function") {
      core.error("`cb` param has to be function");
      return false;
    }

    if (Object.prototype.hasOwnProperty.call(this.event, eventName)) {
      this.event[eventName].push(cb);

      returnCB = cb;
    } else {
      core.error("No such event");
    }

    return returnCB;
  };

  /**
   * function to remove event
   * @param {String} eventName
   * @param {function} cb - callback
   */
  removeEventListener = (eventName, cb) => {
    if (Object.prototype.hasOwnProperty.call(this.event, eventName)) {
      this.event[eventName] = this.event[eventName].filter((e) => e !== cb);
    } else {
      core.error("No such event");
    }
  };
}

const gkevent = new GKEvent();

export default gkevent;
